<!--
科研经费合同到款按时间统计
-->
<template>
  <div style="height: 136px">
    <v-responsive style="height: 80px;">
      <v-container fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <v-list>
              <v-list-tile-title class="text-xs-center">
                <span>{{'科研经费合同到款按时间统计'}}</span>
              </v-list-tile-title>
            </v-list>
            <v-list>
              <v-list-tile>
                <v-list-tile-avatar color="primary">
                  <span class="white--text headline">¥</span>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <span> 统计时间:</span>
                    <span class="subheading" style="color: #0d47a1">{{startDate+'-'+endDate}}</span>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    <span> 万元:</span>
                    <span class="subheading" style="color: #0d47a1">{{amount[0]}}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </div>
</template>

<script>
  const uri = '/api/proj/report/teacher-fund-contract-receive-by-date';
  export default {
    props:["startDate","endDate","userId"],
    data() {
      return {
        amount: 0.0,
        loading:false
      }
    },
    watch:{
      "startDate":'get',
      "endDate":'get',
      "userId":'get'
    },
    created() {
      this.get();
    },
    mounted() {

    },
    computed: {

    },
    methods:{
      get(){
        if(this.loading || !this.startDate || !this.endDate){
          return
        }
        this.loading = true;
        let params = {"incomeDateStart":this.startDate,"incomeDateEnd":this.endDate,"userId":this.userId};
        this.axios.get(uri, {params: params}).then(
          rsp => {
            this.amount = rsp.data.amount;
            this.loading = false;
          })
      }
    }
  }
</script>

<style scoped>

</style>
